import z from 'zod';
export const GEOGRAPHIC_ZONE_ALSACE_MOSELLE = 'alsace_moselle';
export const GEOGRAPHIC_ZONE_GUADELOUPE = 'guadeloupe';
export const GEOGRAPHIC_ZONE_GUYANE = 'guyane';
export const GEOGRAPHIC_ZONE_LA_REUNION = 'la_reunion';
export const GEOGRAPHIC_ZONE_MARTINIQUE = 'martinique';
export const GEOGRAPHIC_ZONE_MAYOTTE = 'mayotte';
export const GEOGRAPHIC_ZONE_METROPOLE = 'metropole';
export const GEOGRAPHIC_ZONE_NOUVELLE_CALEDONIE = 'nouvelle_caledonie';
export const GEOGRAPHIC_ZONE_POLYNESIE_FRANCAISE = 'polynesie_francaise';
export const GEOGRAPHIC_ZONE_SAINT_BARTHELEMY = 'saint_barthelemy';
export const GEOGRAPHIC_ZONE_SAINT_MARTIN = 'saint_martin';
export const GEOGRAPHIC_ZONE_SAINT_PIERRE_ET_MIQUELON = 'saint_pierre_et_miquelon';
export const GEOGRAPHIC_ZONE_WALLIS_ET_FUTUNA = 'wallis_et_futuna';
export const GEOGRAPHIC_ZONES = [
    GEOGRAPHIC_ZONE_METROPOLE,
    GEOGRAPHIC_ZONE_ALSACE_MOSELLE,
    GEOGRAPHIC_ZONE_GUADELOUPE,
    GEOGRAPHIC_ZONE_GUYANE,
    GEOGRAPHIC_ZONE_MARTINIQUE,
    GEOGRAPHIC_ZONE_MAYOTTE,
    GEOGRAPHIC_ZONE_NOUVELLE_CALEDONIE,
    GEOGRAPHIC_ZONE_LA_REUNION,
    GEOGRAPHIC_ZONE_POLYNESIE_FRANCAISE,
    GEOGRAPHIC_ZONE_SAINT_BARTHELEMY,
    GEOGRAPHIC_ZONE_SAINT_MARTIN,
    GEOGRAPHIC_ZONE_SAINT_PIERRE_ET_MIQUELON,
    GEOGRAPHIC_ZONE_WALLIS_ET_FUTUNA,
];
export const geographicZoneValue = z.enum(GEOGRAPHIC_ZONES);
export const geographicZone = (value) => geographicZoneValue.parse(value);
export const isGeographicZone = (value) => geographicZoneValue.safeParse(value).success;
//# sourceMappingURL=geographic-zone.js.map